import { Button, Drawer, Heading, HeadingRow, TabRow } from "cai-fusion";
import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useIntegration } from "../../../contexts/IntegrationContext";

import { ReactComponent as IconCloseSquare } from "../../../../../images/close-square.svg";
import { useEffect, useState } from "react";

import IntegrationConfiguration from "./integrations/integrationConfiguration";
import IntegrationTools from "./integrations/integrationTools";

const ModifyIntegrationDrawer = () => {
    
    const {visibilityStates, hide} = useTransientVisibility();
    const { types, isEditing, currIntegration, setCurrIntegration, currConfigItem, setCurrConfigItem, createIntegration, updateIntegration } = useIntegration();

    const [currTab, setCurrTab] = useState("");

    const placeholderHttpApi = {
        "integrationType": "HttpApi",
        "authenticationType": "None",
        "method": "GET",
    }

    const placeholderDatabase = {
        "integrationType": "Database",
        "authenticationType": "None",
        "databaseProvider": "SqlServer",
    }

    useEffect(() => {
        hide('ModifyIntegrationDrawer')
    }, [])

    useEffect(() => {
        if (isEditing) {
            setCurrTab("config");
        } else {
            setCurrTab("")
        }
    }, [visibilityStates.ModifyIntegrationDrawer])

    const selectType = (type) => {
        // setCurrConfigItem({...type});
        // Replace this later once we flesh out everything
        if (type.id === "HttpApi") {
            setCurrIntegration({...placeholderHttpApi})
        } else {
            setCurrIntegration({...placeholderDatabase})
        }
        setCurrTab("config");
    }

    return (
        <Drawer
            clickOutsideToClose
            isHidden={ !visibilityStates.ModifyIntegrationDrawer }
            onClose={() => hide('ModifyIntegrationDrawer')}
            header={
                <HeadingRow
                    title={`${isEditing ? "Edit" : "Create"} External Integration`}
                    eyebrow="Integrations"
                    size={3}
                >
                    <div className="m-icon-row m-icon-row--right-align">
                        <a
                            id="drawerCloseBtn"
                            className="a-icon m-icon-row__icon"
                            title="Close Associate Details"
                            onClick={() => hide('ModifyIntegrationDrawer')}
                        >
                            <IconCloseSquare className="a-icon-link__icon">
                                {" "}
                            </IconCloseSquare>
                        </a>
                    </div>
                </HeadingRow>
            }
            actions={
                currTab !== "" && 
                <>
                    <Button
                        outline
                        children="Cancel"
                        onClick={() => hide('ModifyIntegrationDrawer')}
                    />
                    <Button
                        children={`${isEditing ? "Update" : "Save"} Integration`}
                        onClick={() => {
                            if (isEditing) {
                                updateIntegration();
                            } else {
                                createIntegration();
                            }
                            hide('ModifyIntegrationDrawer')
                        }}
                    />
                </>
            }
        >
            {/* Purposefully hiding the tabrow until you select the type. */}
            {currTab !== ""
            ?   <>
                    <TabRow
                        tabTitles={["Basic Configuration", "Tools"]}
                        tabIDs={["config", "tools"]}
                        activeTab={currTab}
                        onTabChange={(id) => setCurrTab(id)}
                        className="l-mt-xs l-mb-sm"
                    />
                    {currTab === "config" && <IntegrationConfiguration />}
                    {currTab === "tools" && <IntegrationTools />}
                </>
            :   <>
                    <p className="a-muted-text l-mt-xs l-mb-sm">Select the type of external data connection you want to create.</p>
                    <div className="o-tile-grid">
                        {types.map((type) => (
                            <button className="m-tile m-tile--mini o-tile-grid__tile" onClick={() => selectType(type)} key={type?.id}>
                                <Heading size={6} className="m-tile__title">{type?.name}</Heading>
                                <p className="m-tile__description">{type?.description}</p>
                                <span className="m-tile__cta">Select</span>
                            </button>
                        ))}
                    </div>
                </>
            }
        </Drawer>
    )
}

export default ModifyIntegrationDrawer;